import { useState } from "react";
import { X, Flag } from "lucide-react";
import { toast } from "sonner";
import { getLegal } from "@/lib/legal";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Report-abuse form. Optionally prefilled (e.g. when flagging a chat message).
export default function ReportAbuseModal({ open, language = "English", prefill = "", roomCode = "", onClose }) {
  const t = getLegal(language);
  const [category, setCategory] = useState("piracy");
  const [url, setUrl] = useState(prefill);
  const [details, setDetails] = useState("");
  const [busy, setBusy] = useState(false);

  if (!open) return null;

  const submit = async () => {
    setBusy(true);
    try {
      const res = await fetch(`${API}/report`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ category, url: url.trim(), details: details.trim(), roomCode, language }),
      });
      if (!res.ok) throw new Error("Failed to submit");
      toast.success("Report submitted. Thank you for keeping Ibeflix safe. 🙏");
      setUrl(""); setDetails("");
      onClose();
    } catch (e) {
      toast.error("Couldn't submit the report. Please try again.");
    } finally { setBusy(false); }
  };

  const field = "w-full bg-[#0F1636] border border-white/10 rounded-xl px-3 py-2.5 text-[#F1F1F5] outline-none focus:border-[#00D9FF] text-sm";

  return (
    <div className="fixed inset-0 z-[85] flex items-center justify-center p-4" data-testid="report-abuse-modal">
      <div className="absolute inset-0 bg-black/75 backdrop-blur-sm" onClick={onClose} />
      <div className="relative w-full max-w-md bg-[#0A0E27] border border-white/10 rounded-3xl p-6 shadow-2xl">
        <button data-testid="report-close" onClick={onClose} className="absolute top-4 right-4 text-[#A0A0AB] hover:text-white"><X className="w-5 h-5" /></button>
        <div className="flex items-center gap-2 mb-4">
          <Flag className="w-5 h-5 text-[#00D9FF]" />
          <h2 className="text-lg font-bold text-[#F1F1F5]">{t.report}</h2>
        </div>
        <label className="block text-xs text-[#A0A0AB] mb-1.5">What are you reporting?</label>
        <select data-testid="report-category" value={category} onChange={(e) => setCategory(e.target.value)} className={`${field} mb-3`}>
          <option value="piracy">Pirated / illegal content link</option>
          <option value="harassment">Harassment or abuse</option>
          <option value="spam">Spam</option>
          <option value="other">Other</option>
        </select>
        <label className="block text-xs text-[#A0A0AB] mb-1.5">Link / URL (if any)</label>
        <input data-testid="report-url" value={url} onChange={(e) => setUrl(e.target.value)} placeholder="https://…" className={`${field} mb-3`} />
        <label className="block text-xs text-[#A0A0AB] mb-1.5">Details</label>
        <textarea data-testid="report-details" value={details} onChange={(e) => setDetails(e.target.value)} rows={3} placeholder="Tell us what happened…" className={`${field} mb-4 resize-none`} />
        <button data-testid="report-submit" onClick={submit} disabled={busy}
          className="w-full h-11 rounded-full bg-[#00D9FF] text-navy-ink font-bold hover:bg-[#33E4FF] transition-colors active:scale-95 disabled:opacity-50">
          {busy ? "Submitting…" : "Submit report"}
        </button>
      </div>
    </div>
  );
}
